import { Component, HostBinding, Input } from '@angular/core';
import { NgClass, NgIf } from '@angular/common';
import { AbstractControl } from '@angular/forms';
import { TooltipModule } from 'primeng/tooltip';
import { DebugComponent } from '../../atoms/debug/debug.component';

@Component({
  selector: 'app-form-field-wrapper',
  standalone: true,
  imports: [NgClass, NgIf, TooltipModule, DebugComponent],
  templateUrl: './form-field-wrapper.component.html',
  styleUrl: './form-field-wrapper.component.scss',
})
export class FormFieldWrapperComponent {
  @Input() colSize?: number | string = 12;
  @Input() label? = '';
  @Input() help? = '';
  @Input() name? = '';
  @Input() icon? = '';
  @Input() floatingLabel = true;
  @Input() hideLabel = false;
  @Input() tooltip? = '';
  @Input() formField: AbstractControl | null = null;
  @Input() styleClass = '';

  @HostBinding('class') get columnClass(): string {
    return this.colSize !== 0 ? `col-${this.colSize}` : 'col';
  }
}
